import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const RotatingText = ({
  texts = [],
  rotationInterval = 2000,
  mainClassName = "",
  splitLevelClassName = "",
  staggerFrom = "last",
  staggerDuration = 0.025,
  initial = { y: "100%", opacity: 0 },
  animate = { y: 0, opacity: 1 },
  exit = { y: "-100%", opacity: 0 },
  transition = { type: "spring", damping: 30, stiffness: 400 },
}) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % texts.length);
    }, rotationInterval);

    return () => clearInterval(interval);
  }, [texts.length, rotationInterval]);

  const currentText = texts[index] || "";

  return (
    <div className={`${mainClassName} relative inline-block`}>
      <AnimatePresence mode="wait">
        <motion.div
          key={index}
          initial={initial}
          animate={animate}
          exit={exit}
          transition={transition}
          className="flex justify-center items-center whitespace-pre"
        >
          {currentText.split("").map((char, i) => (
            <motion.span
              key={`${char}-${i}-${index}`}
              className={splitLevelClassName}
              initial={initial}
              animate={animate}
              exit={exit}
              transition={{
                ...transition,
                delay:
                  staggerFrom === "last"
                    ? (currentText.length - i) * staggerDuration
                    : i * staggerDuration,
              }}
            >
              {char}
            </motion.span>
          ))}
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default RotatingText;
